import { Container } from "src/components/container"
import { Image } from "src/components/Image"
import "./style.sass"

export const ShopEverywhere = () => {
  return (
    <div className="shop-everywhere">
      <Container>
        <Image src="/how-to-btc.svg" width={48} height={48} />
        <h1>Shop everywhere with 7Gates crypto card</h1>
        <p>Use 7Gates prepaid crypto card for online or offline shopping or to withdraw cash from the ATM.</p>
        <div className="shop-everywhere__steps">
          <div>
            <img src="/logo-mini.svg" width={32} />
            <p>Shop in millions of stores worldwide (wherever accepted)</p>
          </div>
          <div>
            <img src="/logo-mini.svg" width={32} />
            <p>Make cash withdrawals from any ATM in the world</p>
          </div>
          <div>
            <img src="/logo-mini.svg" width={32} />
            <p>Shop and pay your bills online with one simple click</p>
          </div>
        </div>
      </Container>
    </div>
  )
}
